// Match seating editor (veto seating step + "Edit seating"): which team sits on which side, and the
// 5 seated players of each team. Changes here never touch the teams' default seating.
//   value = { team1_stage_side: 'left'|'right', team1: { seats: [5] }, team2: { seats: [5] } }
//   teams = { team1: { name, players: [{ steam_id, ign }], defaults: [5] }, team2: { … } }
import React from 'react';
import { useTranslation } from 'react-i18next';
import VenueStage from './VenueStage';
import { S, TEAM_TINT } from './StageArt';

const other = (s) => (s === 'left' ? 'right' : 'left');

export function seatingComplete(value) {
  return ['team1', 'team2'].every(k => value[k] && Array.isArray(value[k].seats) && value[k].seats.length === 5 && value[k].seats.every(Boolean) && new Set(value[k].seats).size === 5);
}

export default function MatchSeatingEditor({ teams, value, onChange, readOnly }) {
  const { t } = useTranslation();
  const side1 = value.team1_stage_side || 'left';
  const keyOn = { [side1]: 'team1', [other(side1)]: 'team2' };
  const sideData = (side) => {
    const k = keyOn[side];
    return { name: teams[k].name, tint: TEAM_TINT[k], players: teams[k].players, seats: value[k].seats };
  };
  const changeSeats = (side, seats) => onChange({ ...value, [keyOn[side]]: { seats } });
  const defaultsDiffer = ['team1', 'team2'].some(k => teams[k].defaults && JSON.stringify(teams[k].defaults) !== JSON.stringify(value[k].seats));
  const btnStyle = { padding: '0.45rem 0.85rem', borderRadius: 8, fontWeight: 700, fontSize: '0.8rem', cursor: 'pointer', fontFamily: 'inherit', background: 'rgba(255,255,255,0.05)', border: `1px solid ${S.line3}`, color: S.sub };
  return (
    <div>
      {!readOnly && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: '0.6rem' }}>
          <button type="button" style={btnStyle} onClick={() => onChange({ ...value, team1_stage_side: other(side1) })}>⇄ {t('extSeating.swapSides', 'Swap sides')}</button>
          {defaultsDiffer && (
            <button type="button" style={btnStyle} onClick={() => onChange({ ...value, team1: { seats: teams.team1.defaults || value.team1.seats }, team2: { seats: teams.team2.defaults || value.team2.seats } })}>
              ⟲ {t('extSeating.resetDefaults', 'Use the teams’ default seating')}
            </button>
          )}
          <span style={{ fontSize: '0.74rem', color: S.muted, marginLeft: 'auto' }}>{t('extSeating.swapHint', 'Pick a substitute in a seat to swap them in; picking a seated player swaps the two seats.')}</span>
        </div>
      )}
      <div style={{ background: S.bg, border: `1px solid ${S.line}`, borderRadius: 12, padding: '0.4rem' }}>
        <VenueStage left={sideData('left')} right={sideData('right')} onChange={changeSeats} readOnly={readOnly} />
      </div>
    </div>
  );
}
